/**
 * @generated SignedSource<<2483037a90f6ae6628b6655f38ffb1ea>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type MenuItemType = "ARTICLES" | "EXTERNAL" | "PACKAGES" | "PAGE";
export type CreateMenuItemInput = {
  icon?: string | null;
  name: string;
  type: MenuItemType;
  url?: string | null;
};
export type AddMenuItemDialogMutation$variables = {
  connections: ReadonlyArray<string>;
  id: string;
  input: CreateMenuItemInput;
};
export type AddMenuItemDialogMutation$data = {
  readonly addMenuItemToMenu: {
    readonly node: {
      readonly " $fragmentSpreads": FragmentRefs<"MenuItemsListRow_menuItem">;
    };
  };
};
export type AddMenuItemDialogMutation = {
  response: AddMenuItemDialogMutation$data;
  variables: AddMenuItemDialogMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v3 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  },
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "AddMenuItemDialogMutation",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "MenuItemNode",
        "kind": "LinkedField",
        "name": "addMenuItemToMenu",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "MenuItem",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "MenuItemsListRow_menuItem"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "AddMenuItemDialogMutation",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "MenuItemNode",
        "kind": "LinkedField",
        "name": "addMenuItemToMenu",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "MenuItem",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "type",
                "storageKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "deletable",
                    "storageKey": null
                  }
                ],
                "type": "Entity",
                "abstractKey": "__isEntity"
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "appendNode",
            "key": "",
            "kind": "LinkedHandle",
            "name": "node",
            "handleArgs": [
              {
                "kind": "Variable",
                "name": "connections",
                "variableName": "connections"
              },
              {
                "kind": "Literal",
                "name": "edgeTypeName",
                "value": "MenuItemEdge"
              }
            ]
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "01b3f98ca1600919ddc61550ddfada6f",
    "id": null,
    "metadata": {},
    "name": "AddMenuItemDialogMutation",
    "operationKind": "mutation",
    "text": "mutation AddMenuItemDialogMutation(\n  $id: ID!\n  $input: CreateMenuItemInput!\n) {\n  addMenuItemToMenu(id: $id, input: $input) {\n    node {\n      ...MenuItemsListRow_menuItem\n      id\n    }\n  }\n}\n\nfragment EntityTableRow_entity on Entity {\n  __isEntity: __typename\n  id\n  deletable\n}\n\nfragment MenuItemsListRow_menuItem on MenuItem {\n  id\n  name\n  type\n  ...SortableEntityTableRow_entity\n}\n\nfragment SortableEntityTableRow_entity on Entity {\n  __isEntity: __typename\n  id\n  ...EntityTableRow_entity\n}\n"
  }
};
})();

(node as any).hash = "c9058a866b6c469828cf85083e0d24fd";

export default node;
